import * as ng from 'angular';

ng.module('e360').component('mockDob', {
   templateUrl: require('./mock-dob.component.html')
});